import React from 'react';
import { Col, Row } from 'reactstrap';
import LightBoxGallery from '../common/LightBoxGallery';

const ImageLoader = ({ idx, openImgIndex, src, images }) => {

  const xs = images === 1 ? 1 : (images === 2 || images === 4) ? 6 : (images === 3 && idx === 2) ? 12 : images === 3 ? 6 : (images === 5 && (idx === 4 || idx === 3)) ? 6 : 4;

  return <Col xs={xs} className="p-1">
          <img className="rounded w-100 cursor-pointer" style={{ aspectRatio: '1/1', objectFit: 'contain' }} onClick={() => openImgIndex(idx)} src={src} alt="" />
        </Col>
}

const FeedImageLightbox = ({ images }) => {

  return <LightBoxGallery images={images}>
    {openImgIndex => (
      <Row noGutters className="m-n1">
        {images.map((img, i) => {
          return (
            <ImageLoader key={i} idx={i} src={img} openImgIndex={openImgIndex} images={images.length} />
          )
        })}
      </Row>
    )}
  </LightBoxGallery>
}

export default FeedImageLightbox;